import React, { useEffect, useState } from "react";
import "../../Styles/profile/ProfileLayout.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";
import ScaleLoader from "react-spinners/ScaleLoader";

const UnifiedProfilePage = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState(null);

  // Form States
  const [editFormData, setEditFormData] = useState({});
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // 1. Fetch Profile Data on Mount
  useEffect(() => {
    fetchProfile();
  }, []);
  const fetchProfile = async () => {
    setIsLoading(true);
    try {
      const response = await simplePostCall(
        ApiConfig.ProfileView, // Using studentlist as per your provided snippet
        JSON.stringify({
          customer_id: Number(localStorage.getItem("customer_id")),
          api_key: localStorage.getItem("api_key"),
          language: "en",
          user_id: localStorage.getItem("user_id") || "",
        }),
      );

      if (response?.user && response.user.length > 0) {
        const user = response.user[0];
        setUserData(user);
        // Pre-fill the edit form with fetched data
        setEditFormData({
          firstName: user.user_name,
          lastName: user.user_last_name,
          email: user.user_email,
          contactNumber: user.user_mobile,
          address: user.user_address,
          gender: user.user_gender,
          city: user.user_city,
          nationality: user.user_nationality,
          dateOfBirth: user.user_dob?.split("T")[0],
          joiningDate: user.user_joining_date?.split("T")[0],
          internalNumber: user.user_internal_no,
          user_country_code: user.user_countrycode,
        });
      }
    } catch (error) {
      console.error("Error fetching profile", error);
    } finally {
      setIsLoading(false);
    }
  };
  // 2. Handle Profile Update
  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")),
        api_key: localStorage.getItem("api_key"),
        language: "en",
        user_id: userData?.user_id,
        ...editFormData,
        profilefilePath: userData?.user_profile_pic || "",
      };

      const response = await simplePostCall(
        ApiConfig.UpdateProfileView,
        JSON.stringify(payload),
      );

      if (response?.result) {
        toast.success("Profile updated successfully!");

        setTimeout(() => {
          setActiveTab("overview");
          fetchProfile();
        }, 800); 
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Error updating profile");
    } finally {
      setIsLoading(false);
    }
  };

  // 3. Handle Password Change
  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")),
        api_key: localStorage.getItem("api_key"),
        language: "en",
        user_id: userData?.user_id,
        confirmPassword: passwordData.confirmPassword,
      };

      const response = await simplePostCall(
        ApiConfig.UpdateProfileChangePAssword,
        JSON.stringify(payload),
      );

      if (response?.result) {
        toast.success("Password changed successfully!");
        //  setTimeout(() => {
        setPasswordData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        // }, 500);
      }
    } catch (error) {
      console.error("Error changing password:", error);
      toast.error("Error changing password")
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading && !userData)
    return (
      <div className="text-center p-3">
        <ScaleLoader
          color="#F4BB44"
          style={{ textAlign: "center", padding: "10px" }}
        />
      </div>
    );

  return (
    <div className="profile-wrapper">
      <ToastContainer />
      <div className="profile-card">
        <div className="profile-body">
          <ul className="profile-tabs">
            <li onClick={() => setActiveTab("overview")}>
              <span className={activeTab === "overview" ? "active" : ""}>
                Overview
              </span>
            </li>
            <li onClick={() => setActiveTab("edit")}>
              <span className={activeTab === "edit" ? "active" : ""}>Edit</span>
            </li>
            <li onClick={() => setActiveTab("password")}>
              <span className={activeTab === "password" ? "active" : ""}>
                Change Password
              </span>
            </li>
          </ul>

          <hr className="tab-divider" />

          <div className="tab-content">
            {/* OVERVIEW SECTION */}
            {activeTab === "overview" && userData && (
              <div className="profile-content">
                <div className="profile-box">
                  <div className="profile-left">
                    <img
                      src={
                        userData.user_profile_pic ||
                        "https://stage.edsys.in/uploads/general/user.png"
                      }
                      alt="Avatar"
                      className="profile-avatar"
                    />
                    <h5>{`${userData.user_name} ${userData.user_last_name}`}</h5>
                    <p>{userData.user_role}</p>
                    <table className="profile-table">
                      <thead>
                        <tr>
                          <th colSpan="2">Contact Information</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Email</td>
                          <td>{userData.user_email}</td>
                        </tr>
                        <tr>
                          <td>Email Status</td>
                          <td>
                            <span
                              className={`status-badge ${userData.user_email_verification === "yes" ? "success" : "warning"}`}
                            >
                              {userData.user_email_verification === "yes"
                                ? "Verified"
                                : "Not Verified"}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>Phone</td>
                          <td>
                            {userData.user_countrycode} {userData.user_mobile}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="profile-box">
                  <table className="profile-table">
                    <thead>
                      <tr>
                        <th colSpan="2">General Information</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Address</td>
                        <td>{userData.user_address}</td>
                      </tr>
                      <tr>
                        <td>City</td>
                        <td>{userData.user_city}</td>
                      </tr>
                      <tr>
                        <td>Nationality</td>
                        <td>{userData.user_nationality}</td>
                      </tr>
                      <tr>
                        <td>Joining Date</td>
                        <td>
                          {new Date(userData.user_joining_date).toDateString()}
                        </td>
                      </tr>
                      <tr>
                        <td>Date of Birth</td>
                        <td>{new Date(userData.user_dob).toDateString()}</td>
                      </tr>
                      <tr>
                        <td>Internal No.</td>
                        <td>
                          <span className="status-badge info">
                            {userData.user_internal_no}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* EDIT SECTION */}
            {activeTab === "edit" && (
              <div className="profile-content edit-mode">
                <form
                  className="profile-edit-form"
                  onSubmit={handleUpdateProfile}
                >
                  <div className="two-column-form">
                    <div className="form-column">
                      <div className="form-group">
                        <label>First Name</label>
                        <input
                          type="text"
                          value={editFormData.firstName || ""}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              firstName: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          value={editFormData.email || ""}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Address</label>
                        <textarea
                          rows="3"
                          value={editFormData.address || ""}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              address: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Date of Birth</label>
                        <input
                          type="date"
                          value={editFormData.dateOfBirth || ""}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              dateOfBirth: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="form-column">
                      <div className="form-group">
                        <label>Last Name</label>
                        <input
                          type="text"
                          value={editFormData.lastName || ""}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              lastName: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Mobile</label>
                        <input
                          type="text"
                          value={editFormData.contactNumber || ""}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              contactNumber: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>City</label>
                        <input
                          type="text"
                          value={editFormData.city || ""}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              city: e.target.value,
                            })
                          }
                        />
                      </div>
                      <button
                        type="submit"
                        className="btn-primary full-btn"
                        disabled={isLoading}
                      >
                        {isLoading ? "Updating..." : "Update"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            )}

            {/* PASSWORD SECTION */}
            {activeTab === "password" && (
              <div className="password-section">
                <form className="password-form" onSubmit={handleChangePassword}>
                  <div className="password-field">
                    <label>New Password</label>
                    <input
                      type="password"
                      required
                      value={passwordData.newPassword}
                      onChange={(e) =>
                        setPasswordData({
                          ...passwordData,
                          newPassword: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="password-field">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      required
                      value={passwordData.confirmPassword}
                      onChange={(e) =>
                        setPasswordData({
                          ...passwordData,
                          confirmPassword: e.target.value,
                        })
                      }
                    />
                  </div>
                  <button
                    className="full-btn"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Change"}
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnifiedProfilePage;
